import React, { useState } from 'react';
import { Play } from 'lucide-react';
export function WelcomeVideo() {
  const [isPlaying, setIsPlaying] = useState(false);
  return <section className="py-24 bg-accent-50" data-id="element-190" data-mp="2jnd9mpobyuss">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-191" data-mp="24xo4ykh148nr">
        <div className="text-center mb-12" data-id="element-192" data-mp="24v333vgqdsq0">
          <h2 className="text-3xl md:text-4xl font-title font-bold mb-4" data-id="element-193" data-mp="29vhbjem8v4ok">
            A warm welcome
          </h2>
          <p className="text-stone-600 text-lg max-w-2xl mx-auto" data-id="element-194" data-mp="2xn4tv85fx7f8">
            Take a moment to hear from me directly about how we might work
            together.
          </p>
        </div>

        {/* Welcome video — replace the placeholder with an embed or <video> source */}
        <div className="relative aspect-video rounded-3xl overflow-hidden bg-stone-900 shadow-xl group" data-id="element-195" data-mp="2slz0r97vbi56">
          {isPlaying ? <iframe className="absolute inset-0 w-full h-full" src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" title="Welcome from Dr. Scott Conkright" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-196" data-mp="1d4f2qlmvsrde" /> : <>
              <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1400&q=80" alt="Welcome video preview" className="w-full h-full object-cover opacity-80" data-id="element-197" data-mp="fshlsgf32g5z" />
              <div className="absolute inset-0 bg-stone-900/30" data-id="element-198" data-mp="kqj3awwv27fc" />
              <button onClick={() => setIsPlaying(true)} aria-label="Play welcome video" className="absolute inset-0 flex items-center justify-center" data-id="element-199" data-mp="knwukty8hlvj">
                <span className="flex items-center justify-center w-20 h-20 rounded-full bg-white/90 text-brand-800 shadow-lg group-hover:scale-110 transition-transform" data-id="element-200" data-mp="18fllc5veq2ad">
                  <Play className="h-8 w-8 ml-1 fill-current" data-id="element-201" data-mp="13ibtykogjgjw" />
                </span>
              </button>
            </>}
        </div>
      </div>
    </section>;
}